import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontRegisterModuleTypes from '@/store/modules/frontDesk/register/interface';

const frontRegisterModule: Module<FrontRegisterModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
      sendSmsRegister(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/login/sendSmsRegister", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      sendSmsRegisterNext(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/login/sendSmsRegisterNext", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      saveRegister(context, params) {
          return new Promise((resolve, reject) => {
              tool.post("/login/saveRegister", params).then(data => {
                  if (data.status === 2000) {
                      resolve(data);
                  }
                  else {
                      reject(data);
                  }
              });
          });
      },
    },
};

export default frontRegisterModule;